import { Grid, Section } from '@gogame/components';
import { FormFieldGroup, withArrayFormField } from '@gogame/form';

import { ProductPageComponent } from 'scenes/Campaigns/components/Form/components';

import {
  CAMPAIGNS,
  CPP_PARAMS,
  ANDROID_CPP_FIELD,
  IOS_CPP_FIELD,
} from '../constants';

const IOS = 2;
const ANDROID = 3;

export const CPPField = ({ label, disabled }) => {
  return (
    <Grid item xs={12}>
      <Section
        title={`${label} Custom Product Page`}
        subTitle={'URL params for custom product page'}
      >
        <ProductPageComponent name={CPP_PARAMS} disabled={disabled} />
      </Section>
    </Grid>
  );
};

const MultiCPPFields = withArrayFormField()(({
  value,
  name,
  fields,
  disabled,
}) => {
  return (
    <Grid container spacing={2}>
      {value?.map((campaign, i) => {
        let configFieldName;
        let label;

        switch (campaign.platformId) {
          case ANDROID:
            configFieldName = ANDROID_CPP_FIELD;
            label = 'Android';
            break;
          case IOS:
            configFieldName = IOS_CPP_FIELD;
            label = 'IOS';
            break;
          default:
            configFieldName = '';
        }

        const isFieldVisible = fields[configFieldName];

        return isFieldVisible ? (
          <Grid container item xs={4} key={i}>
            <FormFieldGroup name={`${name}[${i}]`}>
              <CPPField label={label} disabled={disabled} />
            </FormFieldGroup>
          </Grid>
        ) : null;
      })}
    </Grid>
  );
});

export const CPPSection = ({ fields, disabled }) => {
  return (
    <Grid container>
      <MultiCPPFields name={CAMPAIGNS} fields={fields} disabled={disabled} />
    </Grid>
  );
};

export const SingleCPPSection = ({ fields }) => {
  return (
    <Grid container spacing={3}>
      {[ANDROID_CPP_FIELD, IOS_CPP_FIELD].map((parameter) => {
        const isFieldVisible = fields[parameter];

        const label = parameter === ANDROID_CPP_FIELD ? 'Android' : 'IOS';

        return isFieldVisible ? (
          <Grid item xs={4}>
            <Section
              title={`${label} Custom Product Page`}
              subTitle={'URL params for custom product page'}
            >
              <ProductPageComponent name={CPP_PARAMS} disabled={true} />
            </Section>
          </Grid>
        ) : null;
      })}
    </Grid>
  );
};
